import React from 'react';
import { Table } from 'reactstrap';
import { useTranslation } from '../i18n';
import Loading from './Loading';
import Skeleton from './CartSkeleton';
import styles from './Cart.module.scss';
import { FormattedPrice } from './FormattedPrice';

function Cart({ id, state, contents }) {
  const { t } = useTranslation();
  return (
    <>
      {state === 'loading' && (
        <div className="w-100 p-5 my-3 text-center">
          <Skeleton nbrOfRows={3} />
          <Loading />
        </div>
      )}
      {state === 'hasValue' && (
        <Table className={styles.TableLined}>
          <thead>
            <tr>
              <th>{t('cart.product_header')}</th>
              <th className="text-right">{t('cart.quantity_header')}</th>
              <th className="text-right">{t('cart.price_header')}</th>
            </tr>
          </thead>
          <tbody>
            {contents.orderLines?.map((item, index) => (
              <tr key={index}>
                <td>
                  <div className={'d-flex flex-column'}>
                    <span>
                      {item.link ? (
                        <a href={item.link} rel="noopener noreferrer" target="_blank" title={item.description}>
                          {item.description}
                        </a>
                      ) : (
                        item.description
                      )}
                    </span>
                    <small aria-label={t('cart.article_number')}>{item.artNo}</small>
                  </div>
                </td>
                <td className="text-center text-md-right">{item.quantity}</td>
                <td className="text-right">
                  <span className="text-nowrap">
                    <FormattedPrice value={item.totalAmount} />
                  </span>
                </td>
              </tr>
            ))}
            <tr>
              <td colSpan="3" className="text-right">
                <span className="mr-2"> {t('cart.total_label')}</span>
                <span className="text-nowrap">
                  <FormattedPrice value={contents.totalAmount} />
                </span>
              </td>
            </tr>
          </tbody>
        </Table>
      )}
    </>
  );
}

export default Cart;
